import React from "react";
import { capitaliseFirstLetters } from "../../pages/helpers";

interface ICarDetailsProps {
  registration: string;
  manufacturer: string;
  model: string;
  styles?: string;
}

export function CarDetails({
  registration,
  manufacturer,
  model,
  styles
}: ICarDetailsProps) {
  return (
    <div
      className={`ch-display--flex ch-align-items--center ch-mb--3 car-details-container ${styles}`}
    >
      <span className="ch-chip ch-chip--yellow ch-chip--lg variant-reg-chip">
        {registration}
      </span>
      <div className="car-details-titles-container ">
        <p className="ch-text--ellipsis ch-mb--0">
          {manufacturer} {capitaliseFirstLetters(model.toLowerCase())}
        </p>
      </div>
    </div>
  );
}
